export default {
  en: {
    pageTitle: 'Policies',
    empty: {
      title: 'No policies',
      subtitle: 'Add a policy to apply requirements to suppliers',
    },
    addEditPage: {
      saveAdd: 'Save policy',
      saveEdit: 'Save changes',
      learnMore: 'Learn more',
      errors: {
        alreadyExists: "There's already a policy with that name.",
        loading: 'There was an error loading the policy.',
        saving: 'There was an error when trying to save the policy.',
        emptyName: 'The policy must have a name.',
        emptyTagsLabels: 'The policy must include at least 1 tag or label to apply to.',
        emptyMultiselect: 'The policy has required fields that are empty.',
        invalid: 'Validation failed. Please check your changes and try again.',
      },
    },
    controlRow: {
      new: 'New',
      updated: 'Updated',
      newTooltip: 'Risk Ledger recently introduced this control',
      updatedTooltip: 'Risk Ledger recently updated this control',
    },
    row: {
      lastModified: 'Last modified by {0} on {1}',
      appliesToSuppliers: '{n} supplier | {n} suppliers',
      supplierList: '{0} and {1} more ...',
      edit: 'Edit',
      delete: 'Delete',
      duplicate: 'Duplicate',
      modal: {
        title: 'Are you sure you want to delete the policy "{0}"?',
        description:
          "This policy's requirements will stop being applied to {n} supplier | This policy's requirements will stop being applied to {n} suppliers",
        confirm: 'Delete',
        cancel: 'Cancel',
        banner: 'There was a problem while trying to delete the policy',
      },
    },
    controlTypes: {
      nocompliant: 'Require no',
      yescompliant: 'Require yes',
      atleast: 'Require at least',
      atmax: 'Require at most',
    },
    filters: {
      title: 'Filter by',
      placeholder: 'Search by control name...',
      required: 'Required',
      notRequired: 'Not required',
      requiredTitle: 'Required',
      frameworkSizeTitle: 'Framework size',
      domainsTitle: 'Domains',
    },
    form: {
      name: 'Name',
      applies_to_labels: 'Apply to labels',
      applies_to_tags: 'Apply to tags',
      notes: 'Notes',
    },
    controlList: {
      noFilteredAnswers: 'No controls match the filters applied',
      noFilteredAnswersNote: 'Change the filters to show some controls',
    },
    listPage: {
      title: 'Policies',
      addPolicy: 'Add policy',
      messageTitle: 'Customise your supplier policies',
      messageSubtitle:
        'Improve your supply chain with our Risk Ledger templates, designed to match industry standards. You can adjust these policies to fit your needs or create new ones for better compliance control.\n        <br>Remember, these policies affect compliance scores, not the assessment questions. Need more info?',
      linkText: 'Learn more about policies and compliance scores',
      error: 'Failed to load policies. Try again or contact Risk Ledger support.',
    },
    tagLabelSelector: {
      tags: 'Tags',
      labels: 'Labels',
      newLabel: 'Create new label',
    },
    policyMatrix: {
      title: 'Policy matrix',
      policiesRoot: 'Policies',
      export: 'Export',
      domainColumn: 'Domain',
      controlColumn: 'Control',
      empty: 'You have no policies',
      filename: 'riskledger-policy-matrix',
    },
  },
};
